import { defineNuxtPlugin } from '#imports';
import type { CustomVue } from 'vuex';
import type { Cart } from '~/lib/types/cartdata';
import ShopApi from '~/lib/shop-api';
import { captureMessage } from '~/lib/sentry';
import { openModal, closeModal } from '~/composables/modal';
import type { ModalButton } from '@i22-td-smarthome/component-library';

const orderStatesWithCancelModal = ['telekom_payment_transferred', 'brodos_payment_transferred'];
// We have 2 cart states, where the customer should be by the payment provider.
// When he comes back to our page, the cart ist "freezed", so we show the customer a modal to "unfreeze" the cart.
export default defineNuxtPlugin((nuxtApp) => {
  const store = nuxtApp.$store as CustomVue;
  store.watch(
    (state: any) => state.cart.cart?.state,
    (newCartState: Cart['state'] | undefined, oldCartState: Cart['state'] | undefined) => {
      const cart: Cart = store.getters['cart/cartData'];

      if (!orderStatesWithCancelModal.includes(newCartState || '')) {
        // Close modal if open
        if (orderStatesWithCancelModal.includes(oldCartState || '')) {
          closeModal();
        }

        return;
      }

      captureMessage('Die Bestellung muss noch bezahlt werden', {
        contexts: {
          cart: store.getters['cart/getAnonymousCartData'],
        },
        tags: {
          orderKey: cart?.orderKey,
          orderId: cart?.id,
        },
      });

      const buttons: ModalButton[] = [
        {
          name: 'Abbrechen',
          outline: true,
          click: async (closeModalCB) => {
            closeModalCB();
            nuxtApp.$router.push('/shop/warenkorb');
          },
        },
      ];

      let content = 'Die Bestellung muss noch bezahlt werden.';
      const paymentLink = cart.paymentLinkTelekom || cart.paymentLinkBrodos || undefined;
      if (paymentLink) {
        content += '<br>Klicke "Zum Zahlungsanbieter" um die Bestellung zu bezahlen.';
        buttons.push({
          name: 'Zum Zahlungsanbieter',
          primary: true,
          // @ts-ignore
          target: '_self',
          tag: 'a',
          to: paymentLink,
        });
      }
      content +=
        '<br>Klicke "Abbrechen" um den Zahlungsvorgang zu beenden. Du kannst dann eine andere Zahlungsart wählen.';
      openModal({
        closeOnBackdrop: false,
        heading: 'Zahlung ausstehend',
        content,
        buttons,
        onCloseCallback: () => {
          // this is called on every close event - when redirecting to the payment provider, the modal is not closed.
          ShopApi.revertOrderToCart();
        },
      });
    }
  );
});
